import { Box, Grid } from '@mui/material';
import { Helmet } from 'react-helmet';

import Accounts from './Accounts/Accounts';
import Administrators from './Administrators';
import DashBoardSubscriptionRequests from './DashboardSubscriptionRequests';

import { UsersCounter, GroupsCounter, ServicesCounter } from 'Page/Components';
import useTranslate from 'Hooks/useTranslate';
import OrganizationInvite from './OrganizationInvite';
import { useParams } from 'react-router-dom';
import { useCurrentUserInfo } from 'Hooks/useCurrentUserInfo';

function PageDashboard() {
  const ts = useTranslate();
  const { accountCode } = useParams<IUriParams>();
  const { isAdminOfOnlyOneAccount } =  useCurrentUserInfo();

  const displayOrganizationInvite = isAdminOfOnlyOneAccount || accountCode !== 'all';

  return (
    <>
      <Helmet title={ts('page.dashBoard.title')} />
      <Grid container spacing={3}>
        <Grid container item spacing={3}>
          <Grid item xs={12} sm={4}>
            <UsersCounter showButton />
          </Grid>
          <Grid item xs={12} sm={4}>
            <GroupsCounter showButton />
          </Grid>
          <Grid item xs={12} sm={4}>
            <ServicesCounter showButton />
          </Grid>
        </Grid>

        <Grid container item spacing={3}>
          <Grid item xs={12} md={7}>
            <DashBoardSubscriptionRequests />
          </Grid>
          <Grid container item xs={12} md={5} display="flex" direction="column">
            <Box display="flex" flexDirection="column" flexGrow={1} gap={3}>
              <Administrators />
              {displayOrganizationInvite && <OrganizationInvite />}
              <Accounts />
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default PageDashboard;
